import React from "react";

// Renders a single IQ tile spec as crisp SVG geometry.
// kinds: "arrow" {rot}, "dots" {n}, "poly" {sides, rot, fill}
const CYAN = "#06B6D4";

function polyPoints(sides, rot, r = 34, cx = 50, cy = 50) {
  const pts = [];
  const offset = (rot * Math.PI) / 180 - Math.PI / 2;
  for (let i = 0; i < sides; i++) {
    const a = offset + (i * 2 * Math.PI) / sides;
    pts.push(`${(cx + r * Math.cos(a)).toFixed(2)},${(cy + r * Math.sin(a)).toFixed(2)}`);
  }
  return pts.join(" ");
}

function dotPositions(n) {
  const cols = Math.ceil(Math.sqrt(n));
  const rows = Math.ceil(n / cols);
  const gap = 24;
  const startX = 50 - ((cols - 1) * gap) / 2;
  const startY = 50 - ((rows - 1) * gap) / 2;
  const pos = [];
  let count = 0;
  for (let r = 0; r < rows; r++) {
    const inRow = Math.min(cols, n - count);
    const rowStartX = 50 - ((inRow - 1) * gap) / 2;
    for (let c = 0; c < inRow; c++) {
      pos.push([rowStartX + c * gap, startY + r * gap]);
      count++;
    }
  }
  return pos;
}

export const ShapeTile = ({ tile, size = 72 }) => {
  if (!tile) {
    return (
      <div
        className="flex items-center justify-center rounded-lg bg-[#0F172A] border border-dashed border-cyan-500/50"
        style={{ width: size, height: size }}
      >
        <span className="font-sub text-3xl text-cyan-400">?</span>
      </div>
    );
  }

  let inner = null;
  if (tile.kind === "arrow") {
    inner = (
      <g transform={`rotate(${tile.rot} 50 50)`} stroke={CYAN} strokeWidth="6" strokeLinecap="round" fill="none">
        <line x1="50" y1="80" x2="50" y2="26" />
        <polyline points="34,42 50,24 66,42" strokeLinejoin="round" />
      </g>
    );
  } else if (tile.kind === "dots") {
    inner = (
      <g fill={CYAN}>
        {dotPositions(tile.n).map(([x, y]) => (
          <circle key={`${x}-${y}`} cx={x} cy={y} r="7" />
        ))}
      </g>
    );
  } else if (tile.kind === "poly") {
    inner = (
      <polygon
        points={polyPoints(tile.sides, tile.rot || 0)}
        fill={tile.fill === "solid" ? CYAN : "none"}
        stroke={CYAN}
        strokeWidth="5"
        strokeLinejoin="round"
      />
    );
  }

  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className="block">
      {inner}
    </svg>
  );
};
